import React from 'react';

function Header() {
    return (
        <header className="bg-light sticky-top shadow-sm border-bottom header-container">
            <div className="container">
                <nav className="navbar navbar-expand-lg navbar-light bg-light px-0 py-2 position-relative" aria-label="Main navigation">
                    <a className="navbar-brand font-weight-bold my-0" href="/">
                        <span className="text-primary">&lt;</span>Amanur Rahman<span className="text-primary"> /&gt;</span>
                        <span className="badge badge-primary ml-2 font-weight-normal portfolio-badge">PORTFOLIO</span>
                    </a>
                    <button 
                        className="navbar-toggler collapsed p-0" 
                        type="button" 
                        data-toggle="collapse" 
                        data-target="#navbarNav" 
                        aria-controls="navbarNav" 
                        aria-expanded="false" 
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon toggler-icon-open"></span>
                        <span className="toggler-icon-close text-dark font-weight-bold" aria-hidden="true">&times;</span>
                    </button>

                    <div className="collapse navbar-collapse mobile-dropdown-overlay mt-lg-0" id="navbarNav">
                        <ul className="navbar-nav ml-auto align-items-start align-items-lg-center pt-2 pt-lg-0">
                            <li className="nav-item">
                                <a className="nav-link font-weight-medium py-2 py-lg-0 px-lg-3 text-dark" href="/">Projects</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link font-weight-medium py-2 py-lg-0 px-lg-3 text-dark" href="https://amanur.com/#resume" target="_blank" rel="noopener noreferrer">Resume</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link font-weight-medium py-2 py-lg-0 px-lg-3 text-dark" href="https://amanur.com/#about" target="_blank" rel="noopener noreferrer">About</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link font-weight-medium py-2 py-lg-0 px-lg-3 text-dark" href="https://amanur.com/#contact" target="_blank" rel="noopener noreferrer">Contact</a>
                            </li>
                            <li className="nav-item ml-lg-2 mt-3 mt-lg-0 mb-2 mb-lg-0 w-100 w-lg-auto text-left text-lg-center">
                                <a className="btn btn-outline-primary btn-sm rounded-pill px-4 py-2 font-weight-bold" href="https://amanur.com" target="_blank" rel="noopener noreferrer">
                                    Main Site &rarr;
                                </a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </header>
    );
}

export default Header;
